import { candidatesVariables } from "./candidates";
import { referentVariables } from "./referent";
import { userVariables } from "./user";

export const socialOfferVariables = [
  ...candidatesVariables,
  ...referentVariables,
  ...userVariables,
  {
    label: "Liste des offres de service",
    value: "socialOffers",
    variables: [
      { label: "Titre de l'offre", value: "name" },
      { label: "Nom de la structure", value: "providerName" },
      { label: "Période", value: "period" },
      { label: "Lieu", value: "address" },
      { label: "URL", value: "url" },
      { label: "Description", value: "description" },
    ],
    defaultTemplate:
      "{{#each socialOffers}}\r\n{{this.name}} de {{this.providerName}}\r\n{{this.period}}\r\nLieu : {{this.address}}\r\n{{this.url}}\r\n{{{this.description}}}\r\n{{/each}}",
  },
];
